export default __webpack_public_path__ + "static/media/Info_En_Transporte.f07d23b8.png";